export default {"src":"/_next/static/media/cios.ccc832e3.svg","height":28,"width":29,"blurWidth":0,"blurHeight":0};